import * as yup from 'yup';

export const aboveGroundInstallationSchema = yup.object().shape({
	address: yup.string().required('Mailing address is required.'),
	city: yup.string().required('City is required.'),
	state: yup.string().required('State is required.'),
	zip: yup
		.string()
		.required('Zip Code is required.')
		.matches(/[0-9]{5}/g, 'Invalid Zip Code.'),
});
